import colors from '../../../../../config/colors'

export const CHART_HEIGHT = 250
export const LABELS_WIDTH = 28
export const BAR_CHART_LABELS_MARGIN = 22
export const LINE_CHART_LABELS_MARGIN = 57
export const BAR_WIDTH = 72
export const BAR_GAP = 16
export const EXTRA_WIDTH = 44
export const BAR_CHART_MARGINS = { top: 0, right: 0, bottom: 0, left: 0 }
export const LINE_CHART_MARGINS = { top: 5, right: 35, bottom: 5, left: 55 }
export const TICK_STYLE = { fontSize: 10, fontWeight: 500, textAnchor: 'end' }
export const TOOLTIP_WRAPPER_STYLE = { outline: 'none', zIndex: 10 }
export const CURSOR_STYLE = { fill: FinvizSettings.hasDarkTheme ? colors.gray[700] : colors.gray[50], opacity: 0.65 }
export const TRANSPARENT_CURSOR = { opacity: 0 }
